import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IDetailedUser } from '../interfaces';
import { UserMapper } from '../mappers';

export type IGetUsersRepoResponse = IRepoResponse<200, { data: IDetailedUser[]; total: number; lastPage: number }> | IRepoResponse<400 | 500, string>;

export type IGetUsersRepo = IRepo<[any], IGetUsersRepoResponse>;

export const GetUsersRepoType = Symbol.for('GetUsersRepo');

@bind(GetUsersRepoType)
export class GetUsersRepo implements IGetUsersRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/v2/client/list', query) });

      if (result.status === 200) {
        const data: IDetailedUser[] = result.data.data.map((user) => UserMapper.toDomain(user));
        const total: number = result.data.total;
        const lastPage: number = result.data.last_page;
        return {
          status: 200 as 200,
          response: {
            data,
            total,
            lastPage,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
